import { ICostRa } from '~/src/store/reducers/tvPackages';

import * as ST from './styled';

interface IProps {
    selectedPrice: ICostRa,
    prices: ICostRa[],
    onChange: (_price?: ICostRa) => void,
}

const PriceSelection = ({ selectedPrice, prices, onChange }: IProps): JSX.Element => {

    return (
        <ST.PricesWrapper>
            {prices.map(price => {
                const { cost, duration, raId } = price;

                return (
                    <ST.PriceRow key={cost}>
                        <ST.SBaseRadio
                            size={'S'}
                            id={`${raId}`}
                            name={'prices'}
                            value={`${raId}`}
                            checked={raId === selectedPrice.raId}
                            onChange={(value: string) => onChange(prices.find(price => price.raId === +value) as ICostRa)}
                            data-test='price-item'
                        >
                            <ST.InnerContent>
                                <ST.PriceValue>{`${cost} ₽/мес.`}</ST.PriceValue>
                                <ST.PriceDescription>
                                    {duration ? `Подписка на ${duration} мес.` : 'Базовая цена'}
                                </ST.PriceDescription>
                            </ST.InnerContent>
                        </ST.SBaseRadio>
                    </ST.PriceRow>
                );
            })}
        </ST.PricesWrapper>
    );
};

export default PriceSelection;
